import React, { useCallback, useEffect, useMemo } from "react"
import HubspotForm from "react-hubspot-form"

import checkMarkBlue from "../../images/checkmark-new.svg"
import OptimizedImage from "../../utils/OptimizedImage"
import { replaceWithSpan, wrapEmojiWithSpan } from "../../utils/replaceWithSpan"
import screenResponsive from "../../utils/screenResponsive"

import {
  FormWrapper,
  HeroContent as ContentWrapper,
  HeadingWrapper,
  HeadingText,
  IconTitleWrapper,
  BulletItemsWrapper,
  TextItemsWrapper,
  IconItemsWrapper,
  StandardTitleWrapper,
  Eyebrow,
  SubheadingText,
  ListHeading,
  BulletItem,
  BulletItems,
  IconItems,
  IconItem,
  TextItems,
  TextItem,
  FormTitle,
  FormSubtitle,
  FormCard,
  FormHeading,
  SupportSectionWrapper,
  SupportSectionContent,
} from "./styles/HeroSignUp.styled"

const HeroSignUpContent = ({
  isTalkToSales,
  isStandard,
  formId,
  heading,
  icon,
  subheading,
  kicker,
  bulletHeading,
  iconHeading,
  textHeading,
  bulletItems,
  iconItems,
  textItems,
  supportSectionHeading,
  supportContent,
}) => {
  const isTablet = screenResponsive(1024)

  useEffect(() => {
    setTimeout(() => {
      if (typeof window !== "undefined") {
        let imageUrls = [
          "/form/digital-comm.svg",
          "/form/two-way.svg",
          "/form/out-bound.svg",
        ]

        let checkboxDivs = document.querySelectorAll(
          ".form-columns-3 div.hs-fieldtype-booleancheckbox"
        )

        checkboxDivs.forEach(function (div, index) {
          let img = document.createElement("img")

          img.src = imageUrls[index]

          div.appendChild(img)
        })
      }
    }, 1500)
  }, [])

  const bulletContent = useMemo(
    () =>
      bulletItems?.length > 0 && (
        <BulletItemsWrapper isTalkToSales={isTalkToSales}>
          {bulletHeading && <ListHeading>{bulletHeading}</ListHeading>}
          {bulletItems?.length > 0 && (
            <BulletItems isTalkToSales={isTalkToSales}>
              {bulletItems.map((item) => (
                <BulletItem key={item?.textField}>
                  <OptimizedImage src={checkMarkBlue} alt="check icon" />
                  <span>{item?.textField}</span>
                </BulletItem>
              ))}
            </BulletItems>
          )}
        </BulletItemsWrapper>
      ),
    [bulletItems]
  )

  const textContent = useMemo(
    () =>
      textItems?.length > 0 && (
        <TextItemsWrapper isTalkToSales={isTalkToSales}>
          {textHeading && <ListHeading>{textHeading}</ListHeading>}
          {textItems?.length > 0 && (
            <TextItems>
              {textItems?.map((item) => (
                <TextItem key={item?.heading}>
                  {item?.heading && (
                    <h3
                      dangerouslySetInnerHTML={{
                        __html: wrapEmojiWithSpan(item?.heading),
                      }}
                    />
                  )}
                  <span>{item?.subheading}</span>
                </TextItem>
              ))}
            </TextItems>
          )}
        </TextItemsWrapper>
      ),
    [isTalkToSales, textItems]
  )

  const getContent = useCallback(() => {
    if (isTalkToSales) {
      return (
        <>
          {textContent}
          {bulletContent}
        </>
      )
    }
    return (
      <>
        {bulletContent}
        {textContent}
      </>
    )
  }, [isTalkToSales])

  return (
    <ContentWrapper>
      <HeadingWrapper>
        {isStandard && !isTablet && (
          <StandardTitleWrapper>
            {kicker && <Eyebrow>{kicker}</Eyebrow>}
            {icon && (
              <OptimizedImage
                className="package-icon"
                image={icon?.gatsbyImageData}
                src={icon?.url}
                alt={heading}
              />
            )}
            {heading && (
              <HeadingText
                standard
                dangerouslySetInnerHTML={{ __html: replaceWithSpan(heading) }}
              />
            )}
            {subheading && <SubheadingText>{subheading}</SubheadingText>}
          </StandardTitleWrapper>
        )}
        {!isStandard && (
          <IconTitleWrapper main={!isTablet}>
            {icon && (
              <OptimizedImage
                className="package-icon"
                image={icon?.gatsbyImageData}
                src={icon?.url}
                alt={heading}
              />
            )}
            <HeadingText
              standard={isTablet}
              dangerouslySetInnerHTML={{ __html: replaceWithSpan(heading) }}
            />
          </IconTitleWrapper>
        )}
        {getContent()}
        {iconItems?.length > 0 && (
          <IconItemsWrapper>
            {iconHeading && <ListHeading>{iconHeading}</ListHeading>}
            {iconItems?.length > 0 && (
              <IconItems>
                {iconItems.map((item) => (
                  <IconItem
                    key={item?.text}
                    length={item?.text?.split(" ")?.length}
                  >
                    <OptimizedImage
                      src={item?.icon?.url}
                      image={item?.icon?.gatsbyImageData}
                      alt={item.text}
                    />
                    <span>{item.text}</span>
                  </IconItem>
                ))}
              </IconItems>
            )}
          </IconItemsWrapper>
        )}
        {isTalkToSales && (
          <SupportSectionWrapper isTalkToSales={isTalkToSales}>
            {supportSectionHeading && (
              <ListHeading>{supportSectionHeading}</ListHeading>
            )}
            {supportContent && (
              <SupportSectionContent
                dangerouslySetInnerHTML={{ __html: supportContent }}
              />
            )}
          </SupportSectionWrapper>
        )}
      </HeadingWrapper>
      <FormWrapper>
        {isStandard && isTablet && (
          <StandardTitleWrapper>
            {kicker && <Eyebrow>{kicker}</Eyebrow>}
            {icon && (
              <OptimizedImage
                className="package-icon"
                image={icon?.gatsbyImageData}
                src={icon?.url}
                alt={heading}
              />
            )}
            {heading && (
              <HeadingText
                standard
                dangerouslySetInnerHTML={{ __html: replaceWithSpan(heading) }}
              />
            )}
            {subheading && <SubheadingText>{subheading}</SubheadingText>}
          </StandardTitleWrapper>
        )}
        {!isStandard && isTablet && (
          <IconTitleWrapper main={isTablet}>
            {icon && (
              <OptimizedImage
                className="package-icon"
                image={icon?.gatsbyImageData}
                src={icon?.url}
                alt={heading}
              />
            )}
            <HeadingText
              dangerouslySetInnerHTML={{ __html: replaceWithSpan(heading) }}
            />
          </IconTitleWrapper>
        )}
        <FormCard>
          <FormHeading>
            <FormTitle>Connect with our Sales Team</FormTitle>
            <FormSubtitle>
              Fill out your information and our team will reach out to you
            </FormSubtitle>
          </FormHeading>
          <HubspotForm
            portalId={process.env.GATSBY_HUBSPOT_PORTAL_ID}
            formId={formId}
          />
        </FormCard>
      </FormWrapper>
    </ContentWrapper>
  )
}

export default HeroSignUpContent
